import { useRef, useState } from 'react';
import { TaskStatus } from '../../pm/types';
import { STATUS_LABELS, STATUS_ORDER } from '../../pm/constants';
import PortalMenu from './PortalMenu';

interface Props {
  status: TaskStatus;
  onChange: (s: TaskStatus) => void;
}

const StatusPicker: React.FC<Props> = ({ status, onChange }) => {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLSpanElement | null>(null);

  function pick(s: TaskStatus) {
    onChange(s);
    setOpen(false);
  }

  return (
    <span className="pm-status-wrap" ref={triggerRef}>
      <span
        className={`pm-pill pm-status-${status}`}
        onClick={() => setOpen((v) => !v)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setOpen((v) => !v); }}
      >
        {STATUS_LABELS[status]}
      </span>
      <PortalMenu
        open={open}
        triggerRef={triggerRef}
        onDismiss={() => setOpen(false)}
        className="pm-status-menu"
        estimatedHeight={STATUS_ORDER.length * 36 + 16}
      >
        {STATUS_ORDER.map((s) => (
          <button
            key={s}
            className={s === status ? 'active' : ''}
            onClick={() => pick(s)}
          >
            <span className={`pm-status-dot pm-status-${s}`} />
            {STATUS_LABELS[s]}
          </button>
        ))}
      </PortalMenu>
    </span>
  );
};

export default StatusPicker;
